import * as constants from './constants'

export const getRates = ({ grsId, preselectedRateId, waitingListKey, extendingStart, extendingEnd, isExtending }) => ({
    type: constants.GET_RATES,
    grsId,
    preselectedRateId,
    waitingListKey,
    extendingStart,
    extendingEnd,
    isExtending,
})

export const setRates = rates => ({
    type: constants.SET_RATES,
    rates,
})

export const selectRate = selectedRateId => ({
    type: constants.SELECT_RATE,
    selectedRateId,
})

export const clearSelectedRate = () => ({
    type: constants.CLEAR_SELECTED_RATE,
})

export const setSelectedRateDetails = details => ({
    type: constants.SET_SELECTED_RATE_DETAILS,
    details,
})

export const selectCreditCard = card => ({
    type: constants.SET_SELECTED_CREDIT_CARD,
    card,
})

export const selectVehicle = selectedVehicles => ({
    type: constants.SET_SELECTED_VEHICLE,
    selectedVehicles,
})

export const removeFromSelectedVehicles = vehicle => ({
    type: constants.REMOVE_FROM_SELECTED_VEHICLES,
    vehicle,
})

export const setLastBookingDetails = ({ grsId, rateId, subscriptions, waitingListKey, rate, id }) => ({
    type: constants.SET_LAST_BOOKING_DETAILS,
    grsId,
    rateId,
    subscriptions,
    waitingListKey,
    rate,
    id,
})

export const clearLastBookingDetails = () => ({
    type: constants.CLEAR_LAST_BOOKING_DETAILS,
})

export const getBookingLocationDetails = grsId => ({
    type: constants.GET_BOOKING_LOCATION_DETAILS,
    grsId,
})

export const getLocationDataById = grsId => ({
    type: constants.GET_LOCATION_DATA_BY_ID,
    grsId,
})

export const setBookingLocationDetails = locationDetails => ({
    type: constants.SET_BOOKING_LOCATION_DETAILS,
    locationDetails,
})

export const setRawPromoCode = value => ({
    type: constants.SET_RAW_PROMO_CODE,
    value,
})

export const lastBookingRedeemPromoCode = item => ({
    type: constants.LAST_BOOKING_REDEEM_PROMO_CODE,
    item,
})

export const lastBookingRedeemedPromoCode = promoCode => ({
    type: constants.LAST_BOOKING_REDEEMED_PROMO_CODE,
    promoCode,
})

export const lastBookingRemovePromoCode = () => ({
    type: constants.LAST_BOOKING_REMOVE_PROMO_CODE,
})

export const enableCard = cards => ({
    type: constants.ENABLE_CARD,
    cards,
})

export const exitBookingFlow = () => ({
    type: constants.EXIT_BOOKING_FLOW,
})

export const selectSeasonTicket = (ticket, grsId, startDate, waitingListKey) => ({
    type: constants.SELECT_SEASON_TICKET,
    ticket,
    grsId,
    startDate,
    waitingListKey,
})

export const receivedSelectedSeasonTicketRate = rate => ({
    type: constants.RECEIVED_SELECTED_SEASON_TICKET_RATE,
    rate,
})

export const setParkingMode = searchMode => ({
    type: constants.SET_PARKING_MODE,
    searchMode,
})

export const receivedWaitingListRate = rate => ({
    type: constants.RECEIVED_WAITING_LIST_RATE,
    rate,
})

export const lastBookingSetAutoRenew = autoRenew => ({
    type: constants.LAST_BOOKING_SET_AUTO_RENEW,
    autoRenew,
})

export const fetchUpSellOptions = (rateId, lotId, beginTime, endTime) => ({
    type: constants.GET_UPSELL_OPTIONS,
    rateId,
    lotId,
    beginTime,
    endTime,
})

export const setUpSellOptions = upsellOptions => ({
    type: constants.SET_UPSELL_OPTIONS,
    upsellOptions,
})

export const failedToFetchUpSellOptions = error => ({
    type: constants.FAILED_TO_FETCH_UPSELL_OPTIONS,
    error,
})

export const upgradeUpSellBookingDetails = (locationId, rateId, beginTime, endTime, startedWithProductId) => ({
    type: constants.UPGRAGE_UPSELL_RATE,
    locationId,
    rateId,
    beginTime,
    endTime,
    startedWithProductId,
})

export const selectUpSellOption = selectedOption => ({
    type: constants.SELECT_UPSELL_RATE,
    selectedOption,
})

export const clearSelectedUpSellOption = () => ({
    type: constants.CLEAR_SELECTED_UPSELL_RATE,
})

export const getAdditionalParkingItems = (rateId, lotId) => ({
    type: constants.GET_ADDITIONAL_PARKING_ITEMS,
    rateId,
    lotId,
})

export const setAdditionalParkingItems = additionalItems => ({
    type: constants.SET_ADDITIONAL_PARKING_ITEMS,
    additionalItems,
})

export const getAdditionalParkingItemsError = error => ({
    type: constants.GET_ADDITIONAL_PARKING_ITEMS_ERROR,
    error,
})

export const setQRCodeData = qrCodeData => ({
    type: constants.SET_QR_CODE_DATA,
    qrCodeData,
})

export const verify3ds = (challengeURL3DS, challengeData3DS) => ({
    type: constants.VERIFY_3DS,
    challengeURL3DS,
    challengeData3DS,
})

export const challenge3ds = () => ({
    type: constants.CHALLENGE_3DS,
})

export const discardThreeDs = payload => ({
    type: constants.DISCARD_3DS,
    payload,
})

export const setGuestUserPersonalDetails = data => ({
    type: constants.SET_GUEST_USER_PERSONAL_DETAILS,
    data,
})

export const verifyGuestCreditCard = (temporaryToken, nameOnCard) => ({
    type: constants.VERIFY_GUEST_USER,
    temporaryToken,
    nameOnCard,
})

export const verifyGuestCreditCardFailed = error => ({ type: constants.VERIFY_GUEST_USER_FAILED, error })

export const verifyGuestCreditCardSuccess = data => ({ type: constants.VERIFY_GUEST_USER_SUCCESS, data })

export const verifyGuestCreditCardResetState = () => ({ type: constants.VERIFY_GUEST_USER_RESET })
